// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.display-mode-card-par {
  display: flex;
  flex-direction: column;
  /* gap: 1rem; */
  font-size: 1rem;
  padding: 1rem;
  color: var(--surface-g5);
  align-items: center;
  border: 1px solid var(--surface-g0);
  border-radius: 10px;
  background-color: var(--surface-g0);
  cursor: pointer;
}

.display-mode-card-par-active {
  border-color: #0860E6;
  background-color: #fff;
}

.dark .display-mode-card-par {
  color: #fff;
  background-color: #5E5F69;
}

.display-mode-card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.dark .display-mode-card-header {
  color: #fff !important;
}

.dark .display-mode-card-header svg {
  color: #fff !important;
}

.display-card-img-div {
  width: auto;
  height: 100%;
  object-fit: cover;
}

.display-mode-card-img-par {
  height: 200px;
  overflow: hidden;
}

.display-modes-card-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.screen-mode-btn-par {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.screen-mode-btn-par button {
  position: relative;
  margin-right: 0 !important;
}

.disableMode {
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/DisplaySettings/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,mCAAmC;EACnC,mBAAmB;EACnB,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".display-mode-card-par {\n  display: flex;\n  flex-direction: column;\n  /* gap: 1rem; */\n  font-size: 1rem;\n  padding: 1rem;\n  color: var(--surface-g5);\n  align-items: center;\n  border: 1px solid var(--surface-g0);\n  border-radius: 10px;\n  background-color: var(--surface-g0);\n  cursor: pointer;\n}\n\n.display-mode-card-par-active {\n  border-color: #0860E6;\n  background-color: #fff;\n}\n\n.dark .display-mode-card-par {\n  color: #fff;\n  background-color: #5E5F69;\n}\n\n.display-mode-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.dark .display-mode-card-header {\n  color: #fff !important;\n}\n\n.dark .display-mode-card-header svg {\n  color: #fff !important;\n}\n\n.display-card-img-div {\n  width: auto;\n  height: 100%;\n  object-fit: cover;\n}\n\n.display-mode-card-img-par {\n  height: 200px;\n  overflow: hidden;\n}\n\n.display-modes-card-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.screen-mode-btn-par {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n}\n\n.screen-mode-btn-par button {\n  position: relative;\n  margin-right: 0 !important;\n}\n\n.disableMode {\n  cursor: not-allowed;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
